import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import useDeposit from '#app/View/InventoryManagement/Inventory/DepositInventory/hooks/useDeposit';
import DepositEntryPoints from '#app/entrypoints/deposit';
import { Mark } from '#app/typings/mark';

type HookReturn = {
  marks: Mark[];
};

const useMarks = (): HookReturn => {
  const { deposit } = useDeposit();

  const { data: marks } = useSWR<Mark[]>(
    deposit ? generateApiPath(DepositEntryPoints.getMarks, { deposit: deposit as string }) : null,
    getCollection,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    marks: marks ?? [],
  };
};

export default useMarks;
